import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { withTheme } from '@emotion/react';
import { Typography } from '@mui/material';

const  RadioButtonsGroup = (props) => {
  const theme = props.theme
  return (
    <FormControl sx={{mt:'24px', width: props.width ?? '100%'}}>
      <FormLabel sx={{...theme.typography.inputTitle, color:'#292727'}} id="demo-row-radio-buttons-group-label">{props.label}</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        sx={{mt:'23px', gap:{sm:'90px',md:'181px'}}}
      >
        {props.options.map((opt, i) =>(
          <FormControlLabel key={i} value={opt} control={<Radio />} label={<Typography sx={{...theme.typography.inputTitle, color:'#292727'}}>{opt}</Typography>} />
        ))
        }
      </RadioGroup>
    </FormControl>
  );
}

export default withTheme(RadioButtonsGroup);